<template>
  <a-drawer title="日志" :visible="visible" :width="900" @close="onClose">
    <div v-if="spinning" style="padding: 16px"><a-skeleton /></div>
    <div v-else class="drawer-content">
      <code-mirror-component v-model="logContent" :read-only="true" language="shell" />
    </div>
  </a-drawer>
</template>
<script>
import { releaseDeployConsole } from '@/api/project/workflow';
import CodeMirrorComponent from '@/components/CodeMirrorComponent';

export default {
  components: { CodeMirrorComponent },
  props: {
    recordId: {
      type: [Number, String],
      default: null
    },
    ticketId: {
      type: String,
      default: null
    },
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      logContent: '',
      spinning: true
    };
  },
  watch: {
    visible() {
      if (this.visible === true) {
        this.spinning = true;
        this.getConsoleLog();
      }
    }
  },
  methods: {
    onClose() {
      this.logContent = '';
      this.$emit('close');
    },
    getConsoleLog() {
      releaseDeployConsole({ record_id: this.recordId, ticket_id: this.ticketId })
        .then(response => {
          this.logContent = response.data.console;
          this.spinning = false;
        })
        .catch(() => {
          this.spinning = false;
        });
    }
  }
};
</script>
<style lang="less" scoped>
.drawer-content {
  overflow: auto;
  height: 100%;
}
/deep/.ant-drawer-body {
  padding: 0px;
  height: calc(~'100% - 55px');
  padding-bottom: 0px;
}
</style>
